import React  from "react";

import RefImg from '~/assets/images/referrals/list-header.png';

import CardPaginator from "~/components/paginator";
import CardComponent from "./Paginator/Card";
import User          from "~/services/user";


const List = ({referralInitials, getColor})=> {

  return (
    <div className="referral-list">
      <img src={RefImg} />
      <h1> Refferals list</h1>
      <CardPaginator endpoint={User.paginator.referrals} card={CardComponent} options={{referralInitials, getColor}} />
    </div>
  );
};

export default List;
